import { OrderStatus, useDrawer } from '@cat-ecom/pcc-components';
import { StoreAddress } from 'components/dealer-locator/types';
import { NotificationContactDealerDrawer } from 'components/notifications/notifications-contact-dealer-drawer';
import { OrderStatusTypes } from 'components/notifications/types';
import { NOTIFICATION_INDICATOR } from 'components/notifications/utils/constants';
import { useTranslations } from 'next-intl';
import { Notification } from 'services/notifications/types';

const OrderStatusWrapper = ({
  orderStatus,
  storeAddress,
  link,
  reviewLink,
  notification
}: {
  orderStatus: string;
  storeAddress: StoreAddress;
  link: string;
  reviewLink: string;
  notification: Notification;
}) => {
  const t = useTranslations();

  const showContactDealerBtn =
    orderStatus === OrderStatusTypes.OnHold ||
    orderStatus === OrderStatusTypes.OrderProblem;

  const contactDealerDrawer = useDrawer({
    id: 'notification-contact-dealer-drawer'
  });

  return (
    <OrderStatus
      orderDisplayLinkText={t(NOTIFICATION_INDICATOR[orderStatus])}
      CONTACT_DEALER_CARDS={showContactDealerBtn}
      reviewLink={reviewLink}
      link={link}
      handleOpen={contactDealerDrawer.openDrawer}
    >
      <NotificationContactDealerDrawer
        drawer={contactDealerDrawer}
        storeAddress={storeAddress}
        notification={notification}
      />
    </OrderStatus>
  );
};

export default OrderStatusWrapper;
